import { useCallback } from 'react';
import { FormikProps } from 'formik';

export const useFieldError = <Values>(form: FormikProps<Values>) => {
  const { errors, touched } = form;

  return useCallback(
    (field: keyof Values) => Boolean(errors[field] && touched[field]),
    [errors, touched],
  );
};

export default useFieldError;
